import {
    ACCESS_TOKEN_DELETED,
    ACCESS_TOKEN_PENDING,
    ACCESS_TOKEN_DOWNLOADED,
    ACCESS_TOKEN_FAILED,
    ACCESS_TOKEN_POSTING,
    ACCESS_TOKENS_DOWNLOADED,
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: null,
    currentAccessToken: null,
    pending: false,
    sending: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACCESS_TOKEN_PENDING:
            return {
                ...state,
                pending: true,
            };
        case ACCESS_TOKEN_DOWNLOADED:
            let newContent = [];
            let newIndex;
            let id = action.payload.id;
            let at = state.content.find(function (at) {
                return at.id === id;
            });

            if (at) {
                let index = state.content.findIndex(stateApp => {
                    return stateApp.id === at.id;
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload,
                ];
                newIndex = newContent.length - 1;
            }
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentAccessToken: action.payload,
                currentIndex: newIndex,
            };

        case ACCESS_TOKENS_DOWNLOADED:
            let newAccessTokenDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentAccessToken) {
                let newCurrentAccessToken = state.content.find(function (accessToken) {
                    return accessToken.id === state.currentAccessToken.id;
                });
                if (newCurrentAccessToken) {
                    newAccessTokenDownloadedState.currentAccessToken = newCurrentAccessToken;
                    newAccessTokenDownloadedState.currentIndex = newAccessTokenDownloadedState.content.findIndex(
                        (accessToken) => {
                            return newCurrentAccessToken.id === accessToken.id;
                        });
                }
            } else {
                newAccessTokenDownloadedState.currentAccessToken = null;
                newAccessTokenDownloadedState.currentIndex = null;
            }

            return newAccessTokenDownloadedState;
        case ACCESS_TOKEN_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
            };
        case ACCESS_TOKEN_POSTING:
            return {
                ...state,
                sending: true,
            };
        case ACCESS_TOKEN_DELETED:
            let newState = {
                ...state,
                sending: false,
            };

            newState.content = state.content.filter((accessToken) => {
                return accessToken.id !== action.payload;
            });

            if (state.currentAccessToken) {
                if (state.currentAccessToken.id === action.payload) {
                    newState.currentAccessToken = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((accessToken) => {
                        return newState.currentAccessToken.id === accessToken.id;
                    });
                }
            }

            return newState;
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/accessTokens/reducers.js